module.exports = __webpack_public_path__ + "img/doorLogo34.4069bd92.png";